import React, { useState } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import {
  Backdrop, Button, CircularProgress, Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DealershipCard from '../DealershipCard';
import RepairFinderAutocomplete from '../RepairFinderAutocomplete';
import RepairFinderLocateBtn from '../RepairFinderLocateBtn';
import RepairFinderMap from '../RepairFinderMap';

const RepairFinder = ({ confirmSelectedDealership, setShowRepairFinder }) => {
  const { isLoaded: mapIsLoaded, loadError: mapLoadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAdcB5nw8s5mbD8UnBDWR_FS_cEhyGSxJQ',
  });
  const [map, setMap] = useState(null);
  const [selectedDealershipId, setSelectedDealershipId] = useState(null);

  if (!mapIsLoaded) {
    return (
      <Backdrop sx={{ color: '#fff' }} open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (mapLoadError) {
    throw mapLoadError;
  }

  return (
    <>
      <Typography variant="h3" sx={{ mt: '24px', mb: '8px' }}>
        Where are you doing business?
      </Typography>
      <Typography variant="body1" sx={{ mb: '8px' }}>
        Select a location to continue.
      </Typography>
      <Button
        size="small"
        variant="text"
        onClick={() => setShowRepairFinder(false)}
        sx={{ mb: '24px' }}
        startIcon={<ArrowBackIcon />}
      >
        Back to Listings
      </Button>
      { map && (
        <RepairFinderAutocomplete map={map} setSelectedDealershipId={setSelectedDealershipId} />
      )}
      <RepairFinderLocateBtn map={map} />
      <RepairFinderMap
        map={map}
        setMap={setMap}
        selectedDealershipId={selectedDealershipId}
        setSelectedDealershipId={setSelectedDealershipId}
      />
      {selectedDealershipId
        && (
        <DealershipCard
          selectedDealershipId={selectedDealershipId}
          setSelectedDealershipId={setSelectedDealershipId}
          confirmSelectedDealership={confirmSelectedDealership}
        />
        )}
    </>
  );
};

export default RepairFinder;
